



import info_i from "../../assets/i.svg";

import { TwSwitch } from "../../components/tailwind";

export default function StripPaymentMethod(props) {
  const { title, subTitle, infoMessage, defaultSwitch = false, disabled, onSwitchChange, defaultChargeToCustomerSwitch = false, onSwitchChangeChargeToCustomer } = props;

  // console.log("defaultSwitch", defaultSwitch);
  // console.log("defaultChargeToCustomerSwitch", defaultChargeToCustomerSwitch);

  return (
    <div
      className={
        `w-full p-4 md:p-6 flex gap-1 bg-white border border-gray-300 rounded-2xl`
      }
    >
      {/* <img className={"w-17 mt-1.5"} src={payment} alt={""} /> */}
      <div className={"flex flex-col flex-1 gap-2 content-start"}>
        <div className={"flex flex-row items-center gap-3"}>
          <h4 className={"text-base font-semibold text-gray-900"}>
            {title}
          </h4>
        </div>
        <p className={"text-sm text-gray-500"}>
          {subTitle}
        </p>
        {/* <TwSwitch
          title={"Charge to the customer"}
          className={"self-start justify-self-end"}
          // name={"paymentAtVenue"}
          checked={defaultChargeToCustomerSwitch}
          disabled={disabled}
          onChange={onSwitchChangeChargeToCustomer}
        /> */}
        {infoMessage && (<p className={"text-sm text-[#676767] mt-1"}>
          <img className={"w-4 h-4 inline mr-2 align-text-top"} src={info_i} alt={""} /> {infoMessage}
        </p>)}
      </div>
      {/* <div className={"grid justify-items-end content-start"}> */}
      <div className={"flex flex-col content-start"}>
        <TwSwitch
          className={"self-start justify-self-end"}
          // name={"paymentAtVenue"}
          checked={defaultSwitch}
          disabled={disabled}
          onChange={onSwitchChange}
        />
        <div className="flex-1"></div>
      </div>
    </div>
  );
}
